import { Component, Input, OnInit } from '@angular/core';
import { LandingLinkService } from 'app/services/landing-link.service';

@Component({
    selector: 'app-faq-section',
    templateUrl: './faq-section.component.html',
    styleUrls: ['./faq-section.component.scss'],
})
export class FaqSectionComponent implements OnInit {
    @Input() pretitle: string;
    @Input() title: string;
    @Input() points: [{ question: string; answer: string }];
    constructor(public landing: LandingLinkService) {}

    ngOnInit(): void {}

    trackByFn(index: number, item: any): any {
        return item.id || index;
    }
}
